import React from 'react'
import {
  translate,
  List,
  Datagrid,
  TextField,
  EmailField,
  ReferenceManyField,
  Edit,
  DisabledInput,
  TextInput,
  SimpleForm,
  Create,
  SaveButton,
  EditButton,
  Toolbar,
  ViewTitle,
  DateField,
} from 'admin-on-rest'
import { Card } from 'material-ui/Card'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { dateParser } from '../helpers'

export const AdminInstructorsList = props => (
  <List {...props} title={'Lista lectori'}>
    <Datagrid key="id">
      <TextField label="Nume" source="displayName" />
      <TextField label="Telefon" source="phoneNumber" />
      <EmailField source="email" label="Email" />
      <ReferenceManyField
        label="Cursuri"
        reference="courses"
        target="instructors"
      >
        <Datagrid>
          <TextField label="Denumire curs" source="name" />
          <DateField label="Data curs" source="date" parse={dateParser} />
        </Datagrid>
      </ReferenceManyField>
      <EditButton />
    </Datagrid>
  </List>
)



// WEBPACK FOOTER //
// ./src/admin/AdminInstructorsList.js